
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Staff from '../pages/staff/page';
import News from '../pages/news/page';
import NewsDetail from '../pages/news/detail/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/staff',
    element: <Staff />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '/news/:id',
    element: <NewsDetail />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
